export const editorSendObjectToBack = () => {
  const selection = window.canvas && window.canvas.getActiveObject();

  if (!selection) {
    throw new Error('No objects selected');
  }

  if (typeof selection.sendToBack === 'function') {
    selection.sendToBack();
  } else if (window.canvas) {
    // Fallback for non-fabric objects: move to bottom of stack
    window.canvas.sendToBack(selection);
  }
  window.canvas && window.canvas.renderAll();
};
